export const environment = {
    production: false,
    apiUrl: 'https://api.hmg.lxview.lxtech.com.br'
}